import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-registration-action-buttons',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      type="button"
      class="sb-aggro font-light cursor-pointer flex-1 bg-primary-500 text-white rounded-xl py-3 px-3 disabled:bg-zinc-200 disabled:cursor-not-allowed disabled:text-zinc-400"
      (click)="submitForm.emit()"
      [disabled]="!canSubmit()">
      신청하기
    </button>
    <button
      type="button"
      class="sb-aggro font-light cursor-pointer flex-1 bg-white border border-zinc-200 text-zinc-800 rounded-xl py-3 px-3"
      (click)="goBack.emit()">
      이전으로
    </button>
  `,
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        gap: 0.5rem; /* gap-2 */
      }
    `,
  ],
})
export class RegistrationActionButtonsComponent {
  canSubmit = input.required<boolean>();
  submitForm = output<void>();
  goBack = output<void>();
}
